import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="toggle"
export default class extends Controller {
  static targets = ["content", "icon"];

  toggle() {
    this.contentTarget.classList.toggle("hidden");
    
    // Rotate the icon
    if (this.hasIconTarget) {
      this.iconTarget.classList.toggle("rotate-180");
    }
  }
}

